import React, { useEffect, useState } from 'react';
import Card from '../Card';
import FunFact from '../FunFact';
import Hero from '../Hero';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import Cta from '../Cta';
import LogoList from '../LogoList';
import MovingText from '../MovingText';
import PortfolioSlider from '../Slider/PortfolioSlider';
import TestimonialSlider from '../Slider/TestimonialSlider';
import VideoModal from '../VideoModal';
import { pageTitle } from '../../helper';
// Hero Social Links
const heroSocialLinks = [
  {
    name: 'Instagram',
    links: 'https://www.instagram.com/voxmotionco/',
  },
  {
    name: 'LinkedIn',
    links: 'https://www.linkedin.com/company/vox-motion',
  },
];

// FunFact Data
const funfaceData = [
  {
    title: 'Global Happy Clients',
    factNumber: '250',
  },
  {
    title: 'Project Completed',
    factNumber: '800',
  },
  {
    title: 'Industries Served',
    factNumber: '30',
  },
  {
    title: 'Client Statisfaction',
    factNumber: '98%',
  },
];
const portfolioData = [
  
  {
    title: 'AI POWERED SAAS',
    subtitle: 'See Details',
    href: 'https://youtu.be/Q46TLKgeA-c',
   src: '/images/PORTFOLIOCOVER1.jpg',
  },
  {
    title: 'DOCUMENTARY',
    subtitle: 'See Details',
    href: 'https://www.youtube.com/watch?v=rWTit0VMJp0&list=LL&index=2',
    src: '/images/PORTFOLIOCOVER3.jpg',
  },
  {
    title: 'HIGH RETENTION TALKING HEAD',
    subtitle: 'See Details',
    href: 'https://youtu.be/ZdQU8L7Tk_Q',
    src: '/images/PORTFOLIOCOVER2.jpg',
  },
  {
    title: 'VLOG',
    subtitle: 'See Details',
    href: 'https://youtu.be/XdTfaS49zbw',
    src: '/images/PORTFOLIOCOVER4.jpg',
  },
];

export default function Home() {
  pageTitle('Home');
  const [activeVideoSrc, setActiveVideoSrc] = useState(null);
  const [showVideoModal, setShowVideoModal] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleVideoOpen = (videoSrc) => {
    setActiveVideoSrc(videoSrc);
    setShowVideoModal(true);
  };

  const handleVideoClose = () => {
    setShowVideoModal(false);
    setActiveVideoSrc(null);
  };

  return (
    <>


      {/* Start Hero Section */}
      <Hero
        title="Expert Editing <br/> Powerful Stories <br/> Maximum Impact"
        subtitle="We are a premium creative powerhouse for businesses and creators, delivering world-class editing, storytelling, and strategic content solutions that drive engagement and elevate brands."
        btnText="Get a Quote"
        btnLink="/contact"
        scrollDownId="#service"
        socialLinksHeading="Follow Us"
        heroSocialLinks={heroSocialLinks}
        bgImageUrl="/images/mainhero.jpg"
      />
      {/* End Hero Section */}

      {/* Start FunFact Section */}
      <div className="container">
        <FunFact
          variant="cs-type1"
          title="Our Creative Legacy"
          subtitle="At Vox Motion, we see every project as a chance to create something meaningful. The results we've delivered speak to our commitment to quality, professionalism, and creative integrity."
          data={funfaceData}
        />
      </div>
      {/* End FunFact Section */}

      {/* Start Service Section */}
      <Spacing lg="150" md="80" />
      <Div id="service">
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="Services we can help you with"
                subtitle="What Can We Do"
                btnText="See All Services"
                btnLink="/service"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-8">
              <Div className="row">
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Video Editing"
                    link="/service/service-details"
                    src="/images/service 2.jpg"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Motion Graphics & Animation"
                    link="/service/service-details"
                    src="/images/service 4.jpg"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Content Strategy"
                    link="/service/service-details"
                    src="/images/service 1.jpg"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                <Div className="col-lg-3 col-sm-6">
                  <Card
                    title="Brand Design"
                    link="/service/service-details"
                    src="/images/service 3.jpg"
                    alt="Service"
                  />
                  <Spacing lg="0" md="30" />
                </Div>
                <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End Service Section */}

      {/* Start Portfolio Section */}
      <Spacing lg="150" md="50" />
      <Div>
        <Div className="container">
          <SectionHeading
            title="Portfolio to explore"
            subtitle="Latest Projects"
            variant="cs-style1 text-center"
          />
          <Spacing lg="90" md="45" />
        </Div>
        <PortfolioSlider 
          data={portfolioData} 
          onVideoClick={handleVideoOpen}
        />
        
        {/* Video Modal for Portfolio */}
        {showVideoModal && (
          <VideoModal
            videoSrc={activeVideoSrc}
            isOpen={showVideoModal}
            onClose={handleVideoClose}
          />
        )}
      </Div>
      {/* End Portfolio Section */}

      {/* Start Awards Section 

      <Spacing lg="150" md="80" />
      <Div className="cs-shape_wrap_2">
        <Div className="cs-shape_2">
          <Div />
        </Div>
         <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="We get multiple awards"
                subtitle="Our Awards"
                variant="cs-style1"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-7 offset-xl-1"> 
              <TimelineSlider />
            </Div>
          </Div>
        </Div>
      </Div>
      End Awards Section */}

      {/* Start Video Block Section */}
      <Spacing lg="130" md="70" />
      <Div className="container">
        <h2 className="cs-font_50 cs-m0 text-center cs-line_height_4">
        Trusted by leading brands, we bring your vision to life with premium content that reflects our expertise and commitment to excellence
        </h2>
        <Spacing lg="70" md="70" />
        <VideoModal
          videoSrc="https://www.youtube.com/watch?v=p6cpSqswgRQ"
          bgUrl="/images/portfolio-cover.jpg"
        />
      </Div>
      {/* End Video Block Section */}

      {/* Start Team Section 
      <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading
          title="Awesome team <br/>members"
          subtitle="Our Team"
          variant="cs-style1"
        />
        <Spacing lg="85" md="45" />
        <TeamSlider />
      </Div>
      <Spacing lg="150" md="80" />
       End Team Section */}

      {/* Start Testimonial Section */}
      <TestimonialSlider />
      {/* End Testimonial Section */}

      {/* Start Blog Section 
      <Spacing lg="150" md="80" />
      <Div className="cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="Explore recent publication"
                subtitle="Our Blog"
                btnText="View More Blog"
                btnLink="/blog"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-7 offset-xl-1">
              <Div className="cs-half_of_full_width">
                <PostSlider />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
       End Blog Section */}

      {/* Start MovingText Section */}
      <Spacing lg="125" md="70" />
      <MovingText text="Our trusted clients world wide" />
      <Spacing lg="105" md="70" />
      {/* End MovingText Section */}

      {/* Start LogoList Section */}
      <Div className="container">
        <LogoList />
      </Div>
      <Spacing lg="150" md="80" />
      {/* End LogoList Section */}

      {/* Start CTA Section */}
      <Div className="container">
        <Cta
          title="Let's discuss and make <br />something <i>cool </i> together"
          btnText="Apply For Meeting"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
